import React, { useState } from 'react'
import { Tooltip } from 'antd'
import styled from 'styled-components'
import { Flex, icons, ColourButton } from 'portal/lib/primitives'
import { colours, sizes } from '@qflow/theme'

export function OnlyDesignMatchesFilter({ onToggle }) {
  const [onlyShowDesignMatches, setOnlyShowDesignMatches] = useState(
    localStorage.getItem('only-design-matches-filter')
  )

  const toggleFilter = () => {
    const newState =
      !onlyShowDesignMatches || onlyShowDesignMatches === 'false'
        ? 'true'
        : 'false'
    setOnlyShowDesignMatches(newState)
    localStorage.setItem('only-design-matches-filter', newState)
    onToggle(newState)
  }

  return (
    <ButtonContainer>
      <FilterButton
        id="OnlyDesignMatchesFilter"
        onClick={toggleFilter}
        $onlyShowDesignMatches={onlyShowDesignMatches}
      >
        <Tooltip
          title={
            onlyShowDesignMatches === 'true'
              ? 'Only showing records with design matches'
              : 'Only show records with design matches'
          }
        >
          <span>
            <icons.DesignMatch size={sizes.SMALL} /> Only Matches
          </span>
        </Tooltip>
      </FilterButton>
    </ButtonContainer>
  )
}

const ButtonContainer = styled(Flex.Col)`
  flex: 0 0 auto;
  align-items: flex-end;
`
const FilterButton = styled(ColourButton.Basic)`
  border-radius: 25px;
  color: ${({ $onlyShowDesignMatches }) =>
    $onlyShowDesignMatches === 'true' ? colours.ORANGE : colours.DARK_GREY};
  background-color: ${({ $onlyShowDesignMatches }) =>
    $onlyShowDesignMatches === 'true' ? '#FFF2EB' : colours.WHITE};
  border-color: ${({ $onlyShowDesignMatches }) =>
    $onlyShowDesignMatches === 'true' ? colours.ORANGE : colours.BORDER_GREY};

  &:hover {
    background: transparent;
    color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true' ? colours.ORANGE : colours.DARK_GREY};
    border-color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true' ? colours.ORANGE : colours.DARK_GREY};
  }

  &:focus {
    color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true' ? colours.ORANGE : colours.DARK_GREY};
    background-color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true' ? '#FFF2EB' : colours.WHITE};
  }

  &:hover:focus {
    background: transparent;
  }

  > SVG {
    color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true'
        ? colours.ORANGE
        : colours.BATTLESHIP_GREY};
  }

  &:hover > SVG {
    color: ${({ $onlyShowDesignMatches }) =>
      $onlyShowDesignMatches === 'true'
        ? colours.ORANGE
        : colours.CHARCOAL_GREY};
  }
`
